import Vuex from 'vuex';
import Vue from 'vue';
import preferences from './modules/preferences';
import config from './modules/config';
import auth from './modules/auth';
import users from './modules/users';
import caseReports from './modules/caseReports';
import globalAlert from './modules/globalAlert';
import account from './modules/account';
import profile from './modules/profile';
import caseGroups from './modules/caseGroups';
import cases from './modules/cases';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    preferences,
    config,
    auth,
    users,
    caseReports,
    globalAlert,
    account,
    profile,
    caseGroups,
    cases
  },
  plugins: [createPersistedState({
    paths: ['preferences']
  })]
});
